import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withKeys as _withKeys, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, isRef as _isRef, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "evses" }
const _hoisted_2 = { class: "app-wrapper" }
const _hoisted_3 = { class: "section-header" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_5 = { class: "emq-table-footer" }

import { getEvseModelList } from '@/api/evses'
import { SEARCH_FORM_RES_PROPS as colProps } from '@/common/constants'
import EvseModelDrawer from './components/EvseModelDrawer.vue'
import EvseModelFirmwares from './components/EvseModelFirmwares.vue'
import PreWithEllipsis from '@/components/PreWithEllipsis.vue'
import CommonPagination from '@/components/commonPagination.vue'
import useI18nTl from '@/hooks/useI18nTl'
import usePaginationRemember from '@/hooks/usePaginationRemember'
import usePaginationWithHasNext from '@/hooks/usePaginationWithHasNext'
import { ArrowDown, ArrowUp, Refresh, RefreshLeft, Search, Plus } from '@element-plus/icons-vue'
import { pick } from 'lodash'
import useProtocolEnums from '@/hooks/useProtocolEnums'
import SelectOperator from '@/components/SelectOperator.vue'
import { throttleBtn } from '@/common/tools'
import LinkOperator from '@/components/Links/LinkOperator.vue'

import { defineComponent, ref, computed, defineProps } from 'vue'

const __default__ = defineComponent({
  name: 'EvseModels',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { t } = useI18nTl('Evses')

const showEvseModelDialog = ref(false)

const showDialog = ref(false)
const editEditFlag = ref(false)
const showDialogEvse = ref({})

const showMoreQuery = ref(false)
const tableData = ref([])
const lockTable = ref(false)
const TableCom = ref()
const params = ref({})
const fuzzyParams = ref<Record<string, any>>({})
const { enableSelects, evseStateSelects } = useProtocolEnums()
const { pageMeta, pageParams, initPageMeta, setPageMeta, toPageMeta } = usePaginationWithHasNext()
const { updateParams } = usePaginationRemember('evses-detail')
const EvseModelDrawerRef = ref()
const openFirmware = (row: any) => {
  showEvseModelDialog.value = true
  showDialogEvse.value = row
}

const addData = () => {
  editEditFlag.value = false
  showDialogEvse.value = {}
  showDialog.value = true
  EvseModelDrawerRef.value?.clearValidate()
}
const editData = (row: any) => {
  editEditFlag.value = true
  showDialogEvse.value = row
  showDialog.value = true
}

const handleSearch = async () => {
  params.value = genQueryParams(fuzzyParams.value)
  loadDatas({ page: 1 })
}

const handleReset = () => {
  fuzzyParams.value = {}
  handleSearch()
}

const genQueryParams = (params: Record<string, any>) => {
  let newParams: Record<string, any> = {}
  const { id, modelName, vendor, operatorID } = params
  newParams = {
    id: id || undefined,
    modelName: modelName || undefined,
    vendor: vendor || undefined,
    operatorID: operatorID || undefined,
  }
  return newParams
}

const loadDatas = async (_params = {}) => {
  lockTable.value = true
  const sendParams = {
    ...params.value,
    pageReq: {
      ...pageParams.value,
      ..._params,
    },
  }

  try {
    const { lists = [], pageReply = {} } = await getEvseModelList(sendParams)
    const meta = toPageMeta(sendParams.pageReq, pageReply)
    tableData.value = lists
    setPageMeta(meta)
    updateParams({ ...pick(meta, ['limit', 'page']), ...params.value })
  } catch (error) {
    tableData.value = []
    initPageMeta()
  } finally {
    lockTable.value = false
  }
}
const loadDatasRefreshLimit = throttleBtn(loadDatas)

loadDatas()

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_role = _resolveDirective("role")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      class: "search-wrapper",
      onKeyup: _withKeys(handleSearch, ["enter"])
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_row, { gutter: 20 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(_unref(colProps))), {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: fuzzyParams.value.modelName,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((fuzzyParams.value.modelName) = $event)),
                  placeholder: _ctx.$t('Evses.model'),
                  clearable: "",
                  onClear: handleSearch
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 16),
            _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(_unref(colProps))), {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: fuzzyParams.value.vendor,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((fuzzyParams.value.vendor) = $event)),
                  placeholder: _ctx.$t('Evses.vendor'),
                  clearable: "",
                  onClear: handleSearch
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 16),
            _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(_unref(colProps))), {
              default: _withCtx(() => [
                _createVNode(SelectOperator, {
                  modelValue: fuzzyParams.value.operatorID,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((fuzzyParams.value.operatorID) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 16),
            (showMoreQuery.value)
              ? (_openBlock(), _createBlock(_component_el_col, _normalizeProps(_mergeProps({ key: 0 }, _unref(colProps))), {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: fuzzyParams.value.id,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((fuzzyParams.value.id) = $event)),
                      placeholder: _ctx.$t('Evses.id'),
                      clearable: "",
                      onClear: handleSearch
                    }, null, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                }, 16))
              : _createCommentVNode("", true),
            _createVNode(_component_el_col, _mergeProps(_unref(colProps), { class: "col-oper" }), {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  plain: "",
                  icon: _unref(Search),
                  onClick: handleSearch
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('Base.search')), 1)
                  ]),
                  _: 1
                }, 8, ["icon"]),
                _createVNode(_component_el_button, {
                  icon: _unref(RefreshLeft),
                  onClick: handleReset
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('Base.reset')), 1)
                  ]),
                  _: 1
                }, 8, ["icon"]),
                _createVNode(_component_el_tooltip, {
                  content: !showMoreQuery.value ? _ctx.$t('Base.showMore') : _ctx.$t('Base.lessMore'),
                  placement: "top"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      class: "icon-button",
                      plain: "",
                      icon: showMoreQuery.value ? _unref(ArrowUp) : _unref(ArrowDown),
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (showMoreQuery.value = !showMoreQuery.value))
                    }, null, 8, ["icon"])
                  ]),
                  _: 1
                }, 8, ["content"])
              ]),
              _: 1
            }, 16)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["onKeyup"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          type: "primary",
          icon: _unref(Plus),
          onClick: _cache[5] || (_cache[5] = ($event: any) => (addData()))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Base.create')), 1)
          ]),
          _: 1
        }, 8, ["icon"])), [
          [_directive_role, 'evseModelUpsert']
        ]),
        _createVNode(_component_el_button, {
          type: "primary",
          plain: "",
          icon: _unref(Refresh),
          onClick: _unref(loadDatasRefreshLimit)
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Base.refresh')), 1)
          ]),
          _: 1
        }, 8, ["icon", "onClick"])
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: tableData.value,
        ref_key: "TableCom",
        ref: TableCom,
        "row-key": "evseSn"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "model",
            "min-width": "80",
            label: _ctx.$t('Evses.model'),
            align: "center"
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(_component_el_tooltip, {
                content: row.id,
                placement: "top"
              }, {
                default: _withCtx(() => [
                  _createVNode(PreWithEllipsis, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(row.model), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["content"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "operatorName",
            "min-width": "80",
            label: _ctx.$t('Evses.operatorName'),
            show: "false"
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(LinkOperator, {
                id: row.operatorID,
                name: row.operatorName
              }, null, 8, ["id", "name"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "vendor",
            "min-width": "80",
            label: _ctx.$t('Evses.vendor')
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "product",
            "min-width": "80",
            label: _ctx.$t('Evses.product')
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "ratedPower",
            "min-width": "50",
            label: _ctx.$t('Evses.power')
          }, {
            default: _withCtx(({ row }) => [
              _createTextVNode(_toDisplayString(row.ratedPower / 1000) + " KW ", 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('Base.operation'),
            "class-name": "table-operation"
          }, {
            default: _withCtx(({ row }) => [
              _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                size: "small",
                plain: "",
                onClick: ($event: any) => (editData(row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('Base.edit')), 1)
                ]),
                _: 2
              }, 1032, ["onClick"])), [
                [_directive_role, 'evseModelUpsert']
              ]),
              _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                size: "small",
                plain: "",
                onClick: ($event: any) => (openFirmware(row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('Evses.firmware')), 1)
                ]),
                _: 2
              }, 1032, ["onClick"])), [
                [_directive_role, 'evseModelFirmwareUpsert']
              ])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["data"])), [
        [
          _directive_loading,
          lockTable.value,
          void 0,
          { lock: true }
        ]
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(CommonPagination, {
          metaData: _unref(pageMeta),
          "onUpdate:metaData": _cache[6] || (_cache[6] = ($event: any) => (_isRef(pageMeta) ? (pageMeta).value = $event : null)),
          onLoadPage: loadDatas
        }, null, 8, ["metaData"])
      ])
    ]),
    _withDirectives(_createVNode(EvseModelDrawer, {
      ref_key: "EvseModelDrawerRef",
      ref: EvseModelDrawerRef,
      modelValue: showDialog.value,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((showDialog).value = $event)),
      isEdit: editEditFlag.value,
      evseModelInfo: showDialogEvse.value,
      onSubmitted: loadDatas
    }, null, 8, ["modelValue", "isEdit", "evseModelInfo"]), [
      [_directive_role, 'evseModelUpsert']
    ]),
    _withDirectives(_createVNode(EvseModelFirmwares, {
      modelValue: showEvseModelDialog.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((showEvseModelDialog).value = $event)),
      evseModelInfo: showDialogEvse.value
    }, null, 8, ["modelValue", "evseModelInfo"]), [
      [_directive_role, 'evseModelFirmwares']
    ])
  ]))
}
}

})